/*
 * Case 1: takes a regime node with a .$.name property and returns it
 * Case 2: takes a facility node with only a .label property and formats it
 */
export function getFormattedNodeName(node) {
    const name = node?.$?.name ?? node?.label ?? "Group"
    const sliceIndex =
        name.toLowerCase().startsWith("live:") || name.toLowerCase().startsWith("ready:") ? name.indexOf(":") + 1 : 0
    return name.slice(sliceIndex).trim() // removes Live:/Ready: from the start of the node label
}
